import React from 'react'
import { TaskBoardType } from '../../types/task-board'
import { State } from '../../types/state'
import { TaskColumn } from './TaskColumn'
import { TaskBoardTable } from './TaskBoardTable'

interface TaskBoardContentProps {
  board: TaskBoardType
  viewMode: 'columns' | 'table'
  filterMode: 'all' | 'assigned'
  userState: State['user']
  onAddCard: (columnId: string) => void
  onDeleteColumn: (columnId: string) => void
  onUpdateColumnTitle: (columnId: string, title: string) => void
  onCardClick: (columnId: string, cardId: string) => void
  onPriorityClick: (columnId: string, cardId: string) => void
  onDueDateClick: (columnId: string, cardId: string) => void
  onDependencyClick: (columnId: string, cardId: string) => void
  onMoveCard: (cardId: string, sourceColumnId: string, destinationColumnId: string) => void
  onChangeCardPosition: (cardId: string, columnId: string, direction: 'up' | 'down') => void
  onAssignUser: (cardId: string, userId: string | null) => Promise<void>
}

export const TaskBoardContent: React.FC<TaskBoardContentProps> = ({
  board,
  viewMode,
  filterMode,
  userState,
  onAddCard,
  onDeleteColumn,
  onUpdateColumnTitle,
  onCardClick,
  onPriorityClick,
  onDueDateClick,
  onDependencyClick,
  onMoveCard,
  onChangeCardPosition,
  onAssignUser
}) => {
  if (viewMode === 'columns') {
    return (
      <div className='row'>
        <div className='col-sm-12'>
          <div className='task-columns-container d-flex overflow-auto pb-20'>
            {board.columns.map(column => (
              <TaskColumn
                key={column.id}
                column={column}
                board={board}
                filterMode={filterMode}
                userState={userState}
                onAddCard={() => onAddCard(column.id)}
                onDeleteColumn={() => onDeleteColumn(column.id)}
                onUpdateColumnTitle={onUpdateColumnTitle}
                onCardClick={onCardClick}
                onPriorityClick={onPriorityClick}
                onDueDateClick={onDueDateClick}
                onDependencyClick={onDependencyClick}
                onMoveCard={onMoveCard}
                onChangeCardPosition={onChangeCardPosition}
                onAssignUser={onAssignUser}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <TaskBoardTable
      board={board}
      filterMode={filterMode}
      userState={userState}
      onCardClick={onCardClick}
      onDueDateClick={onDueDateClick}
      onDependencyClick={onDependencyClick}
    />
  )
}
